// extracted by mini-css-extract-plugin
export default {"input":"Input1_input__xlXTl"};